import cx from 'classnames';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Translation } from 'react-i18next';
import { connect } from 'react-redux';

import { validateEmail } from '@app/libs/validation';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  documentId: PropTypes.string,
  senderName: PropTypes.string,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  documentId: '',
  senderName: '',
  onCancel() {},
  onSubmit() {},
};

class SendingToMailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validityMessage: '',
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleBlur() {
    const { email } = this.state;
    const { message } = validateEmail(email);
    this.setState({ validityMessage: message });
  }

  handleChange({ target: { value } }) {
    const email = value.trim();
    this.setState({ email });
    const { message } = validateEmail(email);
    this.setState({ validityMessage: message });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.handleBlur();

    const { documentId, senderName, onCancel, onSubmit } = this.props;
    const { email } = this.state;

    onSubmit(documentId, senderName, email);
    onCancel();
  }

  render() {
    const { onCancel } = this.props;
    const { email, validityMessage } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="Container Container--max-xxs">
            <div className="Card Card--pop box-6x align-center">
              <h3 className="space-4x">
                <strong>{t('SendingToMailModal-title')}</strong>
              </h3>
              <p className="space-6x pre-wrap">{t('SendingToMailModal-description')}</p>
              <div className={cx('InputSet', 'space-6x', { 'InputSet--invalid': validityMessage })}>
                <input
                  className="InputSet__text-input"
                  placeholder={t('SendingToMailModal-emailAddress')}
                  type="email"
                  value={email}
                  onBlur={this.handleBlur}
                  onChange={this.handleChange}
                />
                {validityMessage && (
                  <p className="InputSet__invalidity-message">{validityMessage}</p>
                )}
              </div>
              <div>
                <button className="Btn" type="button" onClick={onCancel}>
                  {t('Global-cancel')}
                </button>
                <button
                  className="Btn Btn--primary"
                  data-name="submit-button"
                  disabled={!(email && !validityMessage)}
                  type="submit"
                  onClick={this.handleSubmit}
                >
                  {t('SendingToMailModal-submitButton')}
                </button>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

SendingToMailModal.propTypes = propTypes;
SendingToMailModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  onCancel: modalClose,
};

export default connect(undefined, mapDispatchToProps)(SendingToMailModal);
